import {
  faUserLarge,
  faBookmark,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/member-tools';

export const memberToolsRoutes = {
  memberTools: {
    path: `${parentPath}`,
    key: 'member-tools-dashboard',
    value: headerNames.memberTools,
    icon: faUserLarge,
    QADataTag: 'memberToolsSideNav',
    permission: 'membership.members.view',
  },
  memberSearch: {
    path: `${parentPath}?t=search`,
    key: 'member-tools-member-search',
    value: 'Search',
    alias: 'Search',
    icon: faMagnifyingGlass,
    QADataTag: 'memberSearchSideNav',
    permission: 'membership.members.view',
  },
  invoiceSearch: {
    path: `${parentPath}?t=search&st=invoices`,
    key: 'member-tools-invoice-search',
    value: 'Invoice Search',
    icon: faMagnifyingGlass,
    QADataTag: 'invoiceSearchSideNav',
    permission: 'shopping.members.transactions.view',
  },
  member: {
    path: `${parentPath}/member`,
    key: 'member-tools-user',
    value: 'Member',
    alias: 'Member',
    icon: faMagnifyingGlass,
    QADataTag: 'member',
    permission: 'membership.members.view',
  },
  bookmarked: {
    path: `${parentPath}?t=bookmarked`,
    key: 'member-tools-bookmarked-members',
    value: 'Bookmarked',
    icon: faBookmark,
    QADataTag: 'bookmarkedMemberSideNav',
    permission: 'membership.members.view',
  },
  supportToolsNotFound: {
    path: `${parentPath}/404`,
    key: 'not-found',
    value: 'Not found',
    icon: 'not-found',
    QADataTag: 'memberToolsNotFoundSideNav',
  },
};
